import React from 'react';
import { Paper, Typography } from '@mui/material';

/**
 * ReportCard — the titled white panel used across the mobile Report tab
 * (mockup screen 9). Shared by MobileReport and MobileWaveReport.
 */
const ReportCard = function ReportCard({ title, children }) {
  return (
    <Paper sx={{ p: 2.25, borderRadius: '18px' }}>
      {title ? (
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 700,
            mb: 1.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {title}
        </Typography>
      ) : null}
      {children}
    </Paper>
  );
};

export default ReportCard;
